<template>

  <!-- <Toast :group="page.name" position="bottom-center" /> -->
  <Loader v-if="loader" />

  <div class="page prospetto-consumi">

    <DataTable ref="dt" :value="consumptions" :filters="filters"  responsiveLayout="scroll" scrollDirection="both" exportFilename="prospetto">
      <template #header>
        <div class="flex justify-content-between flex-wrap">
            <div class="flex align-items-center justify-content-center mb-2">
              <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
              </span>
            </div>
            <div class="flex align-items-center justify-content-center">
              <Button icon="pi pi-external-link" label="Esporta" @click="exportCSV($event)" class="p-button-secondary" />
              <!-- <Button icon="pi pi-external-link" label="Esporta Cst" @click="exportCsvCustom($event)" class="p-button-secondary" /> -->
            </div>
        </div>
      </template>

        <Column field="code" header="Pod" :sortable="true"></Column>
        <Column field="cliente" header="Cliente" :sortable="true"></Column>
        <Column field="rappresentante" header="Rappresentante" :sortable="true"></Column>
       


        <Column v-for="col of columnsMonth" :field="col" :header="col" :key="col" class="date-col" :exportable="false">
           <template #body="{data}">
              <div class="grid">
                <div class="col-5">
                  <h6>ASK</h6>
                  <div v-if="'f_tot' in data.consumi[col].letture"><b class="head">F_TOT:</b> <small class="val">{{data.consumi[col].letture['f_tot'].toFixed(2)}}</small></div>
                  <div v-if="'pot_max' in data.consumi[col].letture"><b class="head">POT_MAX:</b> <small class="val">{{data.consumi[col].letture['pot_max'].toFixed(2)}}</small></div>
                  <div v-if="'tipo' in data.consumi[col].letture"><b class="head">TIPO:</b> <small class="val">{{data.consumi[col].letture['tipo']}}</small></div>
                </div>
                <div class="col-1 divider"> <div></div></div>
                <div class="col-5">
                  <h6>FORNITORE</h6>
                  <div v-if="'f_tot' in data.consumi[col].fornitori"><b class="head">F_TOT:</b> <small class="val">{{data.consumi[col].fornitori['f_tot'].toFixed(2)}}</small></div>
                  <div v-if="'pot_max' in data.consumi[col].fornitori"><b class="head">POT_MAX:</b> <small class="val">{{data.consumi[col].fornitori['pot_max'].toFixed(2)}}</small></div>
                  <div v-if="'tipo' in data.consumi[col].fornitori"><b class="head">TIPO:</b> <small class="val">{{data.consumi[col].fornitori['tipo']}}</small></div>
                </div>
              </div>   
            </template>
        </Column>
        
        <!------------------------ only for export csv --------------------------------->
        <Column v-for="col of columnsMonth" :field="`tipo_${col}`" :header="col" :key="col" class="date-col" style="display:none">
        </Column>
        <!------------------------ only for export csv --------------------------------->

    </DataTable>

  </div>

</template>

<script>

import { ref, getCurrentInstance, onMounted } from 'vue';
import Service from '@/services/ask-operation/operation-service'
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'
// import { useToast } from "primevue/usetoast";

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Loader
  },
    
  setup(props) {
    const page = { name: 'pods-prospetto-consumi'}
    const loader = ref(false)
    // const toast = useToast();

    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const filters = ref({
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
    });
    const dt = ref();
    const items = ref(props.data)
    const consumptions = ref([]);
    const columnsMonth = ref([]);
    

    onMounted(() => {
      loader.value = true
      service.getProspettoConsumi(items.value).then((res) =>{
        // console.log(res);
        consumptions.value = res.items.pods
        columnsMonth.value = res.items.months
        
      })
      .finally(()=>{
        loader.value = false
      })
    })

    const exportCSV = () => {
      dt.value.exportCSV();
    };

    // const exportCsvCustom = (event) => {
    //   // addFlatValueForExportCsv()
    //   console.log(event);
    //   console.log(dt.value);
    // }
     
    //  const addFlatValueForExportCsv = () => {
    //   console.log(consumptions.value);
    //  }


    return {
      page,
      filters,
      dt,
      items,
      consumptions,
      loader,
      columnsMonth,
      exportCSV,
      // exportCsvCustom
    }
  }
}


</script>
<style>
.prospetto-consumi .p-datatable .p-datatable-tbody > tr > td.date-col  {
  min-width: 340px;
  border-left: 1px solid #f1f1f1;
  border-right: 1px solid #f1f1f1;
  /* padding: 0px !important; */
}
.prospetto-consumi .p-datatable .p-datatable-thead > tr > th.date-col  {
  min-width: 340px;
  border-left: 1px solid #f1f1f1;
  border-right: 1px solid #f1f1f1;
}
.p-datatable .p-datatable-thead > tr > th.date-col  .p-column-header-content{
  display: flex;
  justify-content: center;
  text-align: center;
}
</style>
<style scoped>
.val {
  color: rgb(4, 132, 252);
  font-size: 15px;
}
.head {
  color: darkgrey;
    font-size: 12px;
}
.divider {
   display: flex;
  justify-content: center;

}
.divider div {
 
  width: 1px;
  height: 100%;
  background-color: #f1f1f1;
}


</style>
